<div class="flex-display height-100per" role="main" aria-label="Master Glossary" >
  <div class="width-75 height-100per" *ngIf="outcome">
    <div class="overflow-y-auto height-100per" id="glossaryPage">
      <div class="al-left">
    <div class="display-content">
      <div class="top-heading content-blue" role="heading" aria-level="2">{{masterGlossaryHeader}}</div>
      <div class="mb-1 mt_1">
        <label class="question font-18">{{FilterLabel}}</label>
      </div>
      <div class="flex-display">
        <div class="width-84">
          <input class="searchTopic"
                 [(ngModel)]="filter" (ngModelChange)="onChangeText()" [placeholder]="PlaceholderLabel"
                 type="text">
        </div>
        <div>
          <button mat-button class="btn-cancel" (click)="resetSearchText()" (keyup.enter)="resetSearchText()" tabindex="0">
            {{resetButton}} Filter
          </button>
        </div>
      </div>
    </div>
    <section class="glossarycontent" *ngIf="resultCount > 0">
    <div class="mt-2 print-all-content" >
      <mat-list *ngFor="let group of result">
        <div class="flex-display">
          <div class="leftBox" attr.id="{{group.key}}">
            <span class="alphabets">{{group.key}}</span>
          </div>
          <div class="width-90" >
            <mat-accordion multi>
              <mat-expansion-panel [expanded]="true" *ngFor="let contact of group.contacts" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header [aria-label]="contact.name" class="mataccordianHeader">
                  <div [innerHTML]="contact.name | highlightSearchTerm : filter"></div>
                </mat-expansion-panel-header>
               
                  <div class="ml-32px"  *ngFor="let multiDef of contact.multipleDefinitions; let Index = index">
                    <span *ngIf="contact.multipleDefinitions.length>1">
                      <span class="text-transform-capitalize bold">Definition {{Index + 1}}</span> 
                      <span class="mr_0_5rem ml-0-5">|</span>
                    </span>
                    <span *ngIf="multiDef.type=='sec'" class="text-transform-capitalize">{{secDefinition}}</span>
                    <span *ngIf="multiDef.type=='sec'" class="mr_0_5rem ml-0-5">|</span>
                    <span *ngIf="multiDef.topic.length > 0" class="glossaryTermUsage right-Overlay mr_0_5rem pdf-link"
                      id="glossary-term-usage" [topicData]="multiDef" appHostListenerClick>{{glossaryTermUsage}}</span>
                      <span *ngIf="multiDef.topic.length > 0">
                      <span>|</span>&nbsp;&nbsp;<span class="topic">{{seeTopics}}</span>
                      <span *ngFor="let topic of multiDef.seetopic; let i = index">
                        &nbsp;
                        <span class="topicNum right-Overlay mr_0_5rem pdf-link" id="glossary-term-topic" [glossaryTitle]="contact.name"
                          [topicData]="topic.topicData" appHostListenerClick>{{topic.topic}}</span>
                        <span *ngIf="i != (multiDef.seetopic.length -1)">,</span>
                      </span>
                    </span>
                    <span class="text-transform-uppercase bold topic font-black" *ngIf="multiDef.topic.length == 0">
                      No Incoming Links
                    </span>
                    <p class="glossaryContent" (contextmenu)="onRightClick($event)" (mouseover)="mouseOverFunctions($event)" (click)="OpenLink($event,contact.name)" [innerHTML]="multiDef.capital"></p>
                  </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </mat-list>
      <div class="glossary-border-bottom"></div>
      <div [ngClass]="(totalCount>resultCount)?'align-item-single-line':''" class="print-content-hide">
        <div class="mt-2 width-65" *ngIf="totalCount>resultCount">
          <button mat-button class="load-more-btn pb-1" (click)="loadNextPage()" (keyup.enter)="loadNextPage()" tabindex="0">{{btn_loadmore}}</button>
        </div>
        <div class="links cursor-pointer flex-display pl-13rem float-R text-decoration-none pr-1rem" (click)="setFocus()" *ngIf="enableBackToTop && result.length!=0" (keyup.enter)="setFocus()" tabindex="0">
          <span class="pr-0-5rem mt-2 width-5-5rem font-14">Back to Top</span>
          <span>
            <img src="../../../assets/icons/ArrowUp-white.svg" class="selectedNavElement glossary_arrow_up_icon mt-1-5rem" alt="right up">
          </span>
        </div>
      </div>
    </div>

    </section>
    <div *ngIf="resultCount == 0 && showNoResults">
      <p class="resultNotFound">{{noFoundHeader}}
        <span *ngIf="filter!=''">
          "{{filter}}" 
        </span>
        <span *ngIf="selectedAlphabet!='' && filter!=''">
          &nbsp;{{along_with_filter}}&nbsp;
          </span>
        <span *ngIf="selectedAlphabet!=''">
         "{{selectedAlphabet}}"
        </span>
      </p>
      <span class="font-14">
        {{noFoundDescription}}
      </span>
    </div>
  </div>
  </div>
  </div>
  <div class="al-right" *ngIf="outcome">
    <div class="pt-9rem display-grid justify-content-center">
      <div class="btn-row-margin" *ngFor="let i of [0, 1, 2, 3, 4, 5, 6];">
        <div class="flex-display ">
          <div *ngFor="let alphabet of alphabetsArray[i]">
            <div (click)="goLetter(alphabet)" (keyup.enter)="goLetter(alphabet)" tabindex="0" class="btn-alphabets" [class.btn-selected-alphabet]="this.selectedAlphabet == alphabet" [class.disableAlphabet]="!this.availableAlphabets.includes(alphabet)">
              {{alphabet}}
            </div>
          </div>
        </div>
      </div>
      <div class="btn-row-margin pb-3">
        <div class="ml-68px">
          <button mat-button class="btn-cancel" (click)="ViewAll()" (keyup.enter)="ViewAll()" tabindex="0">
            View All
          </button>
        </div>
      </div>
    </div>
    
  </div>

</div>
